import React from 'react';
import Modal from './../Modal/Modal.index.jsx';
import { toLower } from 'lodash';
import { FormattedMessage } from 'react-intl';
import SelectField from './../Form/Select';
import { Link } from 'react-router';
import dateFormat from 'dateformat';
import { withPermission } from "../../context";

export const BoldedCell = ({ value, searchTerm }) => {
    if (value === null) return null;

    let searchPos = toLower(value).indexOf(toLower(searchTerm));
    let searchTermHtml = <TextCell>{value}</TextCell>;
    if (searchPos > -1) {
        searchTermHtml = <TextCell>{value.substring(0, searchPos)}<strong>{value.substring(searchPos, searchPos + searchTerm.length)}</strong>{value.substring(searchPos + searchTerm.length)}</TextCell>
    }
    return searchTermHtml;
}

export const Cell = ({ children, className }) => <div className={'text-cell ' + (className ? className : "")}>{children}</div>

export const TextCell = ({ children, className }) => <div className={'text-cell ' + (className ? className : "")}>{children}</div>

export const ActionItemsCell = ({ children }) => <div className={'action-items'}>{children}</div>

export const ActiveLabel = ({ isActive, className }) =>
    <span className={(className ? className : "" ) + " label " + (isActive ? "active" : "inactive")}>
        <FormattedMessage id={"General_CoreFunctionality_UIText_general." + (isActive ? "active" : "inactive")}/>
    </span>

export const DeletedLabel = ({ className }) =>
    <span className={(className ? className : "" ) + " label deleted"}>
        <FormattedMessage id={"General_CoreFunctionality_UIText_general.deleted"}/>
    </span>

export const DateCell = ({ timestamp }) => timestamp ? <TextCell>{dateFormat(new Date(timestamp), "mmm dd, yyyy HH:MM")}</TextCell> : null

export const NoResultsModal = ({ term, onClose }) =>
    <Modal buttons={[
        {
            text:    <FormattedMessage id="Entities_CoreFunctionality_UIText_search.entities.modalContinueButton" />,
            primary: true,
            click:   onClose
        }
    ]}
           closeButtonHandler={onClose}>
        <h2 className="modal-header"><FormattedMessage id="Entities_CoreFunctionality_UIText_search.entities.modalStatusMessage" /></h2>
        <div className="divider"></div>
        <div className="modal-check">
            <FormattedMessage id="Entities_CoreFunctionality_UIText_search.entities.modalText" values={{search: <b>{term}</b>}} />
        </div>
    </Modal>;


export const ConfirmationModal = ({ buttons, headerTextId, primaryTextId, secondaryTextId, handleCloseConfirmationModal }) =>
    <Modal buttons={buttons} closeButtonHandler={handleCloseConfirmationModal}>
        <h2 className="modal-header"><FormattedMessage id={headerTextId} /></h2>
        <div className="divider"></div>
        <div className="modal-check">
            <div className="warning">
                <FormattedMessage id={primaryTextId}/>
            </div>
                { secondaryTextId && <div className="warning"><FormattedMessage id={secondaryTextId} /></div> }
        </div>
    </Modal>;

export const DropdownFilter = ({ filter, onChange }) => <SelectField classNames={"filter dropdown-filter filter-" + filter.field} { ...filter} onChange={onChange}/>;

export const ConfirmModal = ({ onConfirm, onConfirmPromise = null, onClose, headerTextId, primaryTextId, secondaryTextId }) => {
    const buttons = [
        {
            text:    <FormattedMessage id="Entities_CoreFunctionality_UIText_search.entities.modalContinueButton" />,
            primary: true,
            click:   onConfirm,
            promise: onConfirmPromise
        },
        {
            text: <FormattedMessage id="General_CoreFunctionality_UIText_general.cancel"/>,
            click: onClose
        }
    ];
    return <ConfirmationModal buttons={buttons} headerTextId={headerTextId} primaryTextId={primaryTextId} secondaryTextId={secondaryTextId} handleCloseConfirmationModal={onClose}/>
}

// Generic component to show a Create <something> button and a border - used only for listing pages
export const ListingPageHeader = ({ buttonMessageId, location, onClick, children = null, className = "", disabled = false,
                                      permission = { canEdit: true }}) => {
    return permission.canEdit ? <div className={'navigation-container ' + className}>
        {children}
        {buttonMessageId && location && <Link to={location} className='button-primary-lg'>
            <FormattedMessage id={buttonMessageId} />
        </Link> }
        { onClick && <button disabled={disabled} onClick={onClick} className={'button-primary-lg'}><FormattedMessage id={buttonMessageId} /></button> }
    </div> : null
}

export const ListingPageHeaderPerm = withPermission(ListingPageHeader);

export const RiskLevel = ({ risk }) => <div className={`risk-level-bullet risk-level-${risk.score}`}>
    {risk.short}
</div>



// WEBPACK FOOTER //
// ./src/scripts/reusable/LightTable/Components.jsx